import { render, staticRenderFns } from "./GiveTransportAccessButton.vue?vue&type=template&id=7f613978&scoped=true"
import script from "./GiveTransportAccessButton.vue?vue&type=script&lang=js"
export * from "./GiveTransportAccessButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f613978",
  null
  
)

export default component.exports